import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        // Respect user's motion preference (SC 2.2.2)
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return
        }

        const self = this
        self.setup()
        self.initCanvas()
        self.initBalls(this.BALL_NUM)
        self.render()

        this.resizeHandler = function() { self.initCanvas() }
        window.addEventListener('resize', this.resizeHandler)
    }

    disconnect() {
        if (this.rafId) {
            cancelAnimationFrame(this.rafId)
        }
        if (this.resizeHandler) {
            window.removeEventListener('resize', this.resizeHandler)
        }
    }

    // 基本設定
    setup(){
        this.rafId = null
        this.canvas = this.element;
        this.can_w = parseInt(this.canvas.getAttribute('width'));
        this.can_h = parseInt(this.canvas.getAttribute('height'));
        this.ctx = this.canvas.getContext('2d');
        if (window.innerWidth <= 991) {
            this.BALL_NUM = 10;
        } else {
            this.BALL_NUM = 30;
        }
        this.ball = {
            x: 0,
            y: 0,
            vx: 0,
            vy: 0,
            r: 0,
            alpha: 1,
            phase: 0
        }
        this.ball_color = "#7785EC"
        this.R = 2
        this.balls = []
        this.alpha_f = 0.03
        this.alpha_phase = 0

        // Line
        this.link_line_width = 0.8,
        this.dis_limit = 260,
        this.add_mouse_point = true,
        this.mouse_in = false,
        this.mouse_ball = {
            x: 0,
            y: 0,
            vx: 0,
            vy: 0,
            r: 0,
            type: 'mouse'
        };
    }

    initCanvas(){
        this.canvas.setAttribute('width', window.innerWidth);
        this.canvas.setAttribute('height', window.innerHeight);
        
        this.can_w = parseInt(this.canvas.getAttribute('width'));
        this.can_h = parseInt(this.canvas.getAttribute('height'));
    }

    initBalls(num){
        for(var i = 1; i <= num; i++){
            this.balls.push({
                x: this.randomSidePos(this.can_w),
                y: this.randomSidePos(this.can_h),
                vx: this.getRandomSpeed('top')[0],
                vy: this.getRandomSpeed('top')[1],
                r: this.R,
                alpha: 1,
                phase: this.randomNumFrom(0, 10)
            });
        }
    } // initBalls

    render(){
        this.ctx.clearRect(0, 0, this.can_w, this.can_h);
        this.renderBalls();
        this.renderLines();
        this.updateBalls();
        this.addBallIfy();
        this.rafId = requestAnimationFrame(() => this.render())
    }

    renderBalls(){
        const self = this
        Array.prototype.forEach.call(this.balls, function(b){
            if(!b.hasOwnProperty('type')){
                self.ctx.fillStyle = self.ball_color;
                self.ctx.beginPath();
                self.ctx.arc(b.x, b.y, self.R, 0, Math.PI*2, true);
                self.ctx.closePath();
                self.ctx.fill();
            }
        });
    }

    renderLines(){
        let fraction, alpha;
        for (let i = 0; i < this.balls.length; i++) {
            for (let j = i + 1; j < this.balls.length; j++) {
                
                fraction = this.getDisOf(this.balls[i], this.balls[j]) / this.dis_limit;
                
                if(fraction < 1){
                    alpha = (1 - fraction).toString();

                    this.ctx.strokeStyle = 'rgba(150,150,150,'+alpha+')';
                    this.ctx.lineWidth = this.link_line_width;
                    
                    this.ctx.beginPath();
                    this.ctx.moveTo(this.balls[i].x, this.balls[i].y);
                    this.ctx.lineTo(this.balls[j].x, this.balls[j].y);
                    this.ctx.stroke();
                    this.ctx.closePath();
                }
            }
        }
    }

    // 移動
    updateBalls(){
        let new_balls = [];
        const self = this
        Array.prototype.forEach.call(this.balls, function(b){
            b.x += b.vx;
            b.y += b.vy;
            
            if(b.x > -(50) && b.x < (self.can_w+50) && b.y > -(50) && b.y < (self.can_h+50)){
                new_balls.push(b);
            }
            
            b.phase += self.alpha_f;
            b.alpha = Math.abs(Math.cos(b.phase));
        });
        
        this.balls = new_balls.slice(0);
    }

    addBallIfy(){
        if(this.balls.length < this.BALL_NUM){
            this.balls.push(this.getRandomBall());
        }
    }

    getRandomBall(){
        const pos = this.randomArrayItem(['top', 'right', 'bottom', 'left']);
        switch(pos){
            case 'top':
                return {
                    x: this.randomSidePos(this.can_w),
                    y: -this.R,
                    vx: this.getRandomSpeed('top')[0],
                    vy: this.getRandomSpeed('top')[1],
                    r: this.R,
                    alpha: 1,
                    phase: this.randomNumFrom(0, 10)
                }
                break;
            case 'right':
                return {
                    x: this.can_w + this.R,
                    y: this.randomSidePos(this.can_h),
                    vx: this.getRandomSpeed('right')[0],
                    vy: this.getRandomSpeed('right')[1],
                    r: this.R,
                    alpha: 1,
                    phase: this.randomNumFrom(0, 10)
                }
                break;
            case 'bottom':
                return {
                    x: this.randomSidePos(this.can_w),
                    y: this.can_h + this.R,
                    vx: this.getRandomSpeed('bottom')[0],
                    vy: this.getRandomSpeed('bottom')[1],
                    r: this.R,
                    alpha: 1,
                    phase: this.randomNumFrom(0, 10)
                }
                break;
            case 'left':
                return {
                    x: -this.R,
                    y: this.randomSidePos(this.can_h),
                    vx: this.getRandomSpeed('left')[0],
                    vy: this.getRandomSpeed('left')[1],
                    r: this.R,
                    alpha: 1,
                    phase: this.randomNumFrom(0, 10)
                }
                break;
        }
    }

    randomSidePos(length){
        return Math.ceil(Math.random() * length);
    }

    getDisOf(b1, b2){
        let delta_x = Math.abs(b1.x - b2.x),
            delta_y = Math.abs(b1.y - b2.y);
        
        return Math.sqrt(delta_x*delta_x + delta_y*delta_y);
    }

    randomArrayItem(arr){
        return arr[Math.floor(Math.random() * arr.length)];
    }
        
    randomNumFrom(min, max){
        return Math.random()*(max - min) + min;
    }

    randomSidePos(length){
        return Math.ceil(Math.random() * length);
    }

    getRandomSpeed(pos){
        let min = -1,
            max = 1;

        switch(pos){
            case 'top':
                return [this.randomNumFrom(min, max), this.randomNumFrom(0.1, max)];
                break;
            case 'right':
                return [this.randomNumFrom(min, -0.1), this.randomNumFrom(min, max)];
                break;
            case 'bottom':
                return [this.randomNumFrom(min, max), this.randomNumFrom(min, -0.1)];
                break;
            case 'left':
                return [this.randomNumFrom(0.1, max), this.randomNumFrom(min, max)];
                break;
            default:
                return;
                break;
        }
    }
}
